import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/** "You've been challenged" notification. Subject is the battle's discussion. */
export default class BattleStartedNotification extends Notification {
  icon() {
    return 'fas fa-bolt';
  }
  href() {
    const discussion = this.attrs.notification.subject();
    return discussion ? app.route.discussion(discussion) : '#';
  }
  content() {
    const user = this.attrs.notification.fromUser();
    const content = this.attrs.notification.content() || {};
    const name = user?.displayName() ?? content.challengerName ?? '?';

    // The `user` param name is reserved by the translator (it calls
    // .displayName() on the value), so {challenger} is used instead.
    return app.translator.trans('forumaker-arena.forum.notifications.battle_started_text', {
      challenger: m("strong", null, name)
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/BattleStartedNotification', BattleStartedNotification);